import * as c from '../constants/actionTypes';
import {
    AFFILIATE_DETAILS_GET,
    AFFILIATE_DETAILS_SUCCESS,
    AFFILIATE_DETAILS_FAILED
} from '../actions/AffiliateDetails'

let initialState = {
    affiliated: false,
    affiliator: false,
    loading: false,
}

export default (state = initialState, action) => {
    switch(action.type) {
        case AFFILIATE_DETAILS_GET:
            var newState = state;
            newState.loading = true;
            return Object.assign({}, newState, state);
        case AFFILIATE_DETAILS_SUCCESS:
            var newState = state;
            newState.affiliated = action.body.data;
            newState.affiliator = action.body.affiliator;
            newState.loading = false;
            return Object.assign({}, newState, state);
        case AFFILIATE_DETAILS_FAILED:
            var newState = state;
            newState.loading = false;
            return Object.assign({}, newState, state);
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AffiliateDetails.js